<template>
<div class="container">
<b-row >
<b-container v-if="fgl_principal">
	<h4>
	<label v-if="listPaises.length!=0" >País</label>
	<select  v-if="listPaises.length!=0" v-model="pais" @click="f_muestra_proveedor()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
	</h4>
	<md-table v-model="listProveedores" md-card md-fixed-header @md-selected="f_muestra">
	<md-table-toolbar>
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.numero_proveedor}}</md-table-cell>
		<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre_proveedor}}</md-table-cell>
		<md-table-cell :md-label="labels.cuantos" class="text-left border">{{item.cuantos}}</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
<b-container v-if="fgl_homologacion">
	<md-table v-model="listHomologaciones" md-card md-fixed-header>
	<md-table-toolbar>
		<h1 class="md-title"><b><i>{{f_titulo_homologacion()}}</i></b></h1>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }">
		<md-table-cell :md-label="labels.referencia_proveedor" class="text-left border">{{item.referencia_proveedor}}</md-table-cell>
		<md-table-cell :md-label="labels.descripcion_proveedor" class="text-left border">{{item.descripcion_proveedor}}</md-table-cell>
		<md-table-cell :md-label="labels.referencia_rappi" class="text-left border">{{item.referencia_rappi}}</md-table-cell>
		<md-table-cell :md-label="labels.descripcion_rappi" class="text-left border">{{item.descripcion_rappi}}</md-table-cell>
		<md-table-cell :md-label="labels.unidad_embalaje" class="text-left border">{{item.unidad_embalaje}}</md-table-cell>
			<md-table-cell :md-label="labels.unidad_embalaje_nueva" class="text-center border"><input v-model="item.unidad_embalaje_nueva" maxlength="6" size="6" @focusout="focusout(item.id,item.unidad_embalaje_nueva)"></md-table-cell>
	</md-table-row>
	</md-table>
	<md-dialog-actions>
		<md-button class="md-accent" @click="grabaHomologacion()">Grabar</md-button>
		<md-button class="md-accent" @click="fgl_homologacion=false;fgl_principal=true">Cerrar</md-button>
	</md-dialog-actions>
</b-container>
</b-row>
</div>
</template>
<script>
import Factura from "@/services/Facturas"

export default {
name:'Homologaciones',
data: () => ({
	pais: '',
	listPaises : [],
	listProveedores : [],
	listHomologaciones : [],
	proveedor:{},
	homologacion: {},
	fgl_principal: true,
	fgl_homologacion: false,
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			identificacion : "Identificación",
			proveedor : "Nombre",
			cuantos : "Homologaciones",
			referencia_proveedor: "Referencia Proveedor",
			descripcion_proveedor: "Descripcion Proveedor",
			referencia_rappi: "Referencia Rappi",
			descripcion_rappi: "Descripcion Rappi",
			unidad_embalaje: "Unidad Empaque",
			unidad_embalaje_nueva: "Nueva Unidad Empaque",
		}
	}else{
		return {
			identificacion : "Identification",
			proveedor : "Name",
		}
	}
}
},
mounted(){
	Factura.leaPaises()
	.then((res) => {
		this.listPaises = res.data.listPaises
	})
	.catch((err) => {
		console.log(err)
	})
},
methods:{
	f_titulo() {
		return "MANTENIMIENTO DE HOMOLOGACIONES"
	},
	f_titulo_homologacion() {
		return "HOMOLOGACIONES "+
			this.proveedor.numero_proveedor+" - "+
			this.proveedor.nombre_proveedor+
			" ("+this.proveedor.cuantos+")"
	},
	f_muestra_proveedor() {
		this.fgl_homologacion=false
		this.listHomologaciones=[]
		Factura.leaProveedoresHomologacion(this.pais)
		.then((res) => {
			this.listProveedores = res.data.listProveedores
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_muestra(r_proveedor) {
		if	(r_proveedor == undefined) {
			return
		}
		this.proveedor = r_proveedor
		this.fgl_homologacion=false
		this.listHomologaciones=[]
		Factura.leaHomologaciones(this.pais,r_proveedor.numero_proveedor)
		.then((res) => {
			this.listHomologaciones = res.data.listHomologaciones
			if	(this.listHomologaciones.length>0) {
				this.fgl_principal=false
				this.fgl_homologacion=true
			}
		})
		.catch((err) => {
			console.log(err)
		})
	},
	grabaHomologacion() {
		Factura.grabaHomologacion(this.listHomologaciones)
		.then(() => {
			this.$toast.success("Cambio Unidad Empaque Correcto")
		})
		.catch(() => {
			this.$toast.error("Problema al cambiar Unidad Empaque")
		})
		this.fgl_principal=true
		this.fgl_homologacion=false
	},
	focusout(idx,embalaje) {
		let vl_idx=-1
		this.listHomologaciones.forEach((homologa,v_idx) => {
			if	(homologa.id == idx) {
				vl_idx=v_idx
			}
		})
		if	(vl_idx==-1) {
			return
		}
		this.listHomologaciones[vl_idx].unidad_embalaje_nueva=embalaje
	},
}

}
</script>

<style>
table {
	table-layout:fixed;
}
.md-table-fixed-header-active {
	border-bottom: 20px solid;
}

</style>
